module.exports = __webpack_public_path__ + "static/img/app.48c45d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/images/app.jpg
// module id = MbFB
// module chunks = 1